import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const DealsFilters = ({ 
  filters, 
  onFiltersChange, 
  onClearFilters, 
  stages = [],
  dealCount,
  onBulkAction,
  selectedCount 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const stageOptions = [
    { value: '', label: 'All Stages' },
    ...stages?.map(s => ({ value: s?.id, label: s?.name }))
  ];

  const priorityOptions = [
    { value: '', label: 'All Priorities' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const activeFiltersCount = Object.values(filters)?.filter(value => 
    value !== '' && value !== null && value !== undefined
  )?.length;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-4">
        <div className="flex items-center space-x-4">
          <h2 className="text-lg font-semibold text-foreground">
            Deals ({dealCount?.toLocaleString()})
          </h2>
          {activeFiltersCount > 0 && (
            <div className="flex items-center space-x-2">
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
                {activeFiltersCount} filter{activeFiltersCount !== 1 ? 's' : ''} active
              </span>
              <Button variant="ghost" size="sm" onClick={onClearFilters} className="text-xs">Clear all</Button>
            </div>
          )}
        </div>
        <Button variant="outline" size="sm" onClick={() => setIsExpanded(!isExpanded)} className="lg:hidden">
          <Icon name="Filter" size={16} className="mr-1" />
          Filters
          <Icon name="ChevronDown" size={16} className={`ml-1 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
        </Button>
      </div>

      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 ${isExpanded ? 'block' : 'hidden lg:grid'}`}>
        <Input
          type="search"
          placeholder="Search deals..."
          value={filters?.search || ''}
          onChange={(e) => handleFilterChange('search', e?.target?.value)}
        />
        <Select
          placeholder="Pipeline Stage"
          options={stageOptions}
          value={filters?.stage || ''}
          onChange={(value) => handleFilterChange('stage', value)}
        />
        <Select
          placeholder="Priority"
          options={priorityOptions}
          value={filters?.priority || ''}
          onChange={(value) => handleFilterChange('priority', value)}
        />
        <div className="flex space-x-2">
          <Input
            type="number"
            placeholder="Min value"
            value={filters?.minValue || ''}
            onChange={(e) => handleFilterChange('minValue', e?.target?.value)}
            className="flex-1"
          />
          <Input
            type="number"
            placeholder="Max value"
            value={filters?.maxValue || ''}
            onChange={(e) => handleFilterChange('maxValue', e?.target?.value)}
            className="flex-1"
          />
        </div>
      </div>

      <div className="hidden lg:flex items-center justify-between mt-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-4">
          <Input
            type="date"
            placeholder="Close date from"
            value={filters?.closeDateFrom || ''}
            onChange={(e) => handleFilterChange('closeDateFrom', e?.target?.value)}
          />
          <Input
            type="date"
            placeholder="Close date to"
            value={filters?.closeDateTo || ''}
            onChange={(e) => handleFilterChange('closeDateTo', e?.target?.value)}
          />
        </div>
        <Button variant="outline" size="sm">
          <Icon name="Download" size={16} className="mr-1" />
          Export All
        </Button>
      </div>
    </div>
  );
};

export default DealsFilters;